(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-video-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-section-type="video-hero"]');
    if (!section) return;

    const playButton = section.querySelector('.video-hero__play-button');
    const video = section.querySelector('.video-hero__video');

    if (playButton && video) {
      playButton.addEventListener('click', function() {
        video.play();
        playButton.classList.add('is-hidden');
      });

      video.addEventListener('pause', function() {
        if (!video.ended) {
          playButton.classList.remove('is-hidden');
        }
      });

      video.addEventListener('ended', function() {
        playButton.classList.remove('is-hidden');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
